import { render, staticRenderFns } from "./VProjectActionForm.vue?vue&type=template&id=434ea180&"
import script from "./VProjectActionForm.vue?vue&type=script&lang=js&"
export * from "./VProjectActionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports